import React from 'react';

import { useFetchJson } from '@xingternal/hops';
import { TextButton } from '@xingternal/button';
import type { TextButtonSizes } from '@xingternal/button';

import {
  URL_COMPLAINTS_API_REPORT,
  URL_COMPLAINTS_API_REPORTS,
} from '../../constants';

export interface ReportButtonProps {
  children: React.ReactNode;
  authorUrn?: string;
  targetUrn?: string;
  onError?: () => void;
  onSuccess?: () => void;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  buttonSize?: TextButtonSizes;
}

export interface Report {
  id?: string;
}

export interface ResponseProps {
  reponse: string;
  report?: Report;
}

export const ReportButton = ({
  children,
  authorUrn,
  targetUrn,
  onError,
  onSuccess,
  onClick,
  className,
  buttonSize,
}: ReportButtonProps) => {
  const fetchJson = useFetchJson();

  const click: any = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick(event);

    const data = {
      author_urn: authorUrn,
      target_urn: targetUrn,
    };
    try {
      const response: ResponseProps = await fetchJson(
        URL_COMPLAINTS_API_REPORTS,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );

      if (response?.report?.id) {
        window.open(
          window.location.origin +
            URL_COMPLAINTS_API_REPORT +
            '/' +
            response.report.id
        );
        onSuccess && onSuccess();
      } else {
        onError && onError();
      }
    } catch (e) {
      onError && onError();
    }
  };
  return (
    <TextButton
      size={buttonSize ?? 'small'}
      onClick={click}
      className={className}
    >
      {children}
    </TextButton>
  );
};

export default ReportButton;
